import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const blockUser = async (userId: string, isBlocked: boolean) => {
  const res = await apiManager.patch(`/admin/user/${userId}/modify`, {
    isBlocked,
  });
  return res;
};

export const useBlockUser = () =>
  useMutation({
    mutationFn: async ({ userId, isBlocked }: { userId: string; isBlocked: boolean }) => {
      const res = await apiClient.patch(`/admin/user/${userId}/modify`, { isBlocked });
      return res.data;
    },
  });
